import $axiosProtected from "../../../common/utils/axiosUtils";

export const getDoctorAppointments = async (payload: any) => {
  return await $axiosProtected().post(
    `/scheduler/schedule-consultation/doctor/status?limit=${payload?.limit}&page=${payload?.page}`,
    payload
  );
};
